export const documents = [
  {
    name: "Lesson Planning",
    items: [
      { name: "Daily Lesson Plan", usage: "Objectives, materials, activities, and assessments for daily lessons." },
      { name: "Weekly Lesson Plan", usage: "Overview of lessons for the entire week." },
      { name: "Unit Plan Template", usage: "Learning outcomes, topics, and resources for a unit." },
      { name: "Substitute Teacher Plan", usage: "Schedule, emergency contacts, and notes for substitute teachers." },
      { name: "Differentiated Instruction Plan", usage: "Strategies to support diverse learners." },
      { name: "Field Trip Planner", usage: "Includes permission slips, itineraries, and emergency contacts for trips." },
      { name: "IEP (Individualized Education Plan)", usage: "Plan for students with special needs." },
      { name: "Lesson Plan Tracker", usage: "Organizes lesson topics, resources, and objectives." },
      { name: "Curriculum Map", usage: "Yearly overview of the lessons to be taught." },
      { name: "Resource Inventory", usage: "List of books, materials, and tools in the classroom." },
      { name: "Assignment Tracker", usage: "Keeps track of due dates, submissions, and completions." },
      { name: "Time Management Planner", usage: "Teacher’s weekly schedule." },
      { name: "Professional Development Tracker", usage: "Logs teacher workshops and development activities." },
      { name: "Daily Agenda Slide", usage: "Displays daily objectives and schedule for students." },
      { name: "Subject Intro Slide", usage: "Provides an overview of a new subject with visuals." },
      { name: "History Timeline", usage: "Editable timeline for historical events." },
      { name: "Science Concept Map", usage: "Flowchart and explanations of scientific concepts." },
      { name: "Math Problem Solver", usage: "Step-by-step math problem-solving." },
      { name: "Literature Analysis", usage: "Breaks down themes and characters in literature." },
      { name: "Geography Lesson", usage: "Interactive map visuals for geography lessons." },
      { name: "Vocabulary Builder", usage: "Word definitions with visuals for vocabulary building." },
    ]
  },
  {
    name: "Classroom Management",
    items: [
      { name: "Classroom Rules Poster", usage: "Customizable poster for classroom rules and consequences." },
      { name: "Behavior Incident Report", usage: "Document student behavior and responses." },
      { name: "Seating Chart Template", usage: "A grid layout for student names in the classroom." },
      { name: "Daily Schedule Template", usage: "Breaks down daily activities and subjects by the hour." },
      { name: "Reward Certificate", usage: "Award for student achievements." },
      { name: "Classroom Emergency Procedures", usage: "Detailed safety protocols for emergencies." },
      { name: "Student-Teacher Agreement", usage: "Contract for classroom behavior and goal-setting." },
      { name: "Class Roster", usage: "Includes names, IDs, and emergency contact details for students." },
      { name: "Behavior Log", usage: "Documents student behaviors and resolutions." },
      { name: "Chore Chart", usage: "Tracks student responsibilities in the classroom." },
      { name: "Tardy Tracker", usage: "Monitors late arrivals of students." },
      { name: "Classroom Budget", usage: "Manages classroom expenses and supplies." },
      { name: "Classroom Fundraising Tracker", usage: "Tracks contributions for classroom fundraisers." },
      { name: "Substitute Teacher Log", usage: "Notes for substitute teacher coverage." },
      { name: "Welcome Slide", usage: "Introduction to the class and teacher." },
      { name: "Rules & Expectations", usage: "Clear visuals for classroom rules and guidelines." },
      { name: "Morning Meeting", usage: "Slide for daily announcements." },
      { name: "Group Work Guidelines", usage: "Roles and expectations for group work." },
      { name: "Transition Timer", usage: "Countdown clock for classroom activities." },
      { name: "Reward Announcement", usage: "Slide to celebrate student achievements." },
      { name: "Class Jobs", usage: "Responsibilities list for class jobs." },
      { name: "Motivational Quote", usage: "Daily inspiration for students." },
    ]
  },
  {
    name: "Assessment & Grading",
    items: [
      { name: "Rubric Template", usage: "Customizable rubric for grading assessments." },
      { name: "Quiz Template", usage: "Multiple-choice and open-ended question formats for quizzes." },
      { name: "Peer Review Form", usage: "Form for students to evaluate each other's work." },
      { name: "Progress Report", usage: "Tracks grades, feedback, and student progress." },
      { name: "Attendance Sheet", usage: "Monthly record of student attendance." },
      { name: "Student Learning Reflection Sheet", usage: "Encourages self-assessment and reflection." },
      { name: "Test Analysis Report", usage: "Tracks performance on various assessments." },
      { name: "Gradebook", usage: "Automatically calculates assignment and test scores." },
      { name: "Test Score Analyzer", usage: "Charts student performance trends over time." },
      { name: "Rubric Calculator", usage: "Assigns weighted scores to projects and assessments." },
      { name: "Attendance Tracker", usage: "Auto-tallies student absences and tardies." },
      { name: "Homework Completion Tracker", usage: "Logs missing assignments and deadlines." },
      { name: "Standards Progress Tracker", usage: "Monitors mastery of skills in the curriculum." },
      { name: "Student Growth Chart", usage: "Tracks student academic progress." },

    ]
  },
  {
    name: "Student Activities",
    items: [
      { name: "Group Project Planner", usage: "Assigns roles, tasks, and deadlines for group projects." },
      { name: "Reading Log", usage: "Track books, pages, and reflections during reading." },
      { name: "Creative Writing Prompt Sheet", usage: "Provides starter sentences and word banks for creative writing." },
      { name: "Science Lab Report", usage: "Template for documenting scientific experiments." },
      { name: "Math Worksheet Template", usage: "Includes space for math problems and solutions." },
      { name: "Student Goal Tracker", usage: "Helps set and track academic goals for students." },
      { name: "Interactive Notebook Template", usage: "Organized template for student learning reflections." },
      { name: "Group Project Scorecard", usage: "Evaluates team contributions in group projects." },
      { name: "Reading Challenge Tracker", usage: "Logs books read by students." },
      { name: "Math Game Scores", usage: "Tracks scores for math class games." },
      { name: "Science Experiment Log", usage: "Records lab results from scientific experiments." },
      { name: "Vocabulary Tracker", usage: "Logs new words and their meanings." },
      { name: "Student Participation Log", usage: "Measures student engagement in class." },
      { name: "Independent Study Planner", usage: "Organizes student research for independent studies." },
      { name: "Peer Collaboration Log", usage: "Tracks teamwork and collaborative efforts." },
      { name: "Quiz Review", usage: "Questions and answers for quiz review." },
      { name: "Test Prep Jeopardy", usage: "Interactive review game for test prep." },
      { name: "Rubric Breakdown", usage: "Visual explanation of assessment criteria." },
      { name: "Progress Chart", usage: "Graphs showing student achievement." },
      { name: "Feedback Slide", usage: "Constructive feedback for student improvement." },
      { name: "Goal Setting", usage: "Setting SMART goals with students." },
      { name: "Exam Tips", usage: "Strategies to succeed in exams." },
      { name: "Project Showcase", usage: "Highlights student work in projects." },
      { name: "Math Madness", usage: "Game where students solve math equations." },
      { name: "Classroom Q&A", usage: "Interactive slide for question and answer sessions." },
      { name: "End-of-Term Recap", usage: "Review of all major topics covered." },
      { name: "Field Trip Recap", usage: "Pictures and details of recent field trips." },
      { name: "Student Reflection", usage: "Allows students to reflect on their learning." },
      { name: "Peer Review Guidelines", usage: "Steps for students to review each other's work." },
      { name: "Parent-Teacher Conference Review", usage: "Key points discussed during conferences." },
      { name: "Safety Procedures", usage: "Classroom safety guidelines and protocols." },
      { name: "Student Celebrations", usage: "Highlight student milestones and accomplishments." },
      { name: "Group Collaboration", usage: "Collaboration tips for group work." },
      { name: "Classroom Tour", usage: "Visuals of the classroom setup and layout." },
      { name: "End-of-Year Review", usage: "Recap of student progress throughout the year." },
      { name: "Class Poll Results", usage: "Shows results from classroom surveys." },
      { name: "Special Guest Speaker", usage: "Introduction of a guest speaker with highlights." },
      { name: "Parent Newsletter", usage: "Updates and news for parents." },
      { name: "Community Involvement", usage: "Students’ participation in community events." },
      { name: "Thank You Slide", usage: "Final slide thanking students and parents." }
    ]
  },
  {
    name: "Parent Communication",
    items: [
      { name: "Newsletter Template", usage: "For monthly updates and announcements to parents." },
      { name: "Parent-Teacher Conference Form", usage: "Agenda and notes for parent-teacher conferences." },
      { name: "Homework Reminder Notice", usage: "Notice for parents about upcoming homework deadlines." },
      { name: "Volunteer Sign-Up Sheet", usage: "List of classroom needs for parent volunteers." },
      { name: "Permission Slip", usage: "Document for parent signatures for school events." },
      { name: "End-of-Year Parent Letter", usage: "Summary of student progress at the end of the year." },
      { name: "Parent Contact List", usage: "Names, emails, and phone numbers of parents." },
      { name: "Conference Scheduler", usage: "Manages conference meeting time slots." },
      { name: "Survey Results", usage: "Analyzes parent feedback surveys." },
      { name: "Event Attendance Log", usage: "Tracks RSVPs and attendance for school events." },
      { name: "Volunteer Hours Log", usage: "Records parent volunteer hours." },
      { name: "IEP Progress Tracker", usage: "Monitors student accommodations under IEP." },
      { name: "Parent Communication Log", usage: "Records emails, phone calls, and communication with parents." },
      { name: "Field Trip Payment Tracker", usage: "Manages fee collection for school trips." }
    ]
  },
];
